import { render, staticRenderFns } from "./IntakeHeader.vue?vue&type=template&id=14735c85&scoped=true"
import script from "./IntakeHeader.vue?vue&type=script&lang=js"
export * from "./IntakeHeader.vue?vue&type=script&lang=js"
import style0 from "./IntakeHeader.vue?vue&type=style&index=0&id=14735c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14735c85",
  null
  
)

export default component.exports